import app from '../../../../package.json'

export const isActiveQueryDevtools = process.env.TARGET_ENV === 'development'

export const APP_NAME_VERSION = `${app.name}_v${app.version}`

export enum APP_MEMBERSHIP_COMMUNITY_CONSUME_HOT_HTTP_INSTANCES {
  API_CONTENT_GATEWAY = 'APP_MEMBERSHIP_COMMUNITY_CONSUME_API_CONTENT_GATEWAY_INSTANCE',
  API_SPARKLE = 'APP_MEMBERSHIP_COMMUNITY_CONSUME_API_SPARKLE_INSTANCE',
  API_SCRAPER = 'APP_MEMBERSHIP_COMMUNITY_CONSUME_API_SCRAPER_INSTANCE',
  API_VULCANO = 'APP_MEMBERSHIP_COMMUNITY_CONSUME_API_VULCANO_INSTANCE',
  API_ONBOARDING = 'APP_MEMBERSHIP_COMMUNITY_CONSUME_API_ONBOARDING_INSTANCE',
  API_HOTMART_AI = 'APP_MEMBERSHIP_COMMUNITY_CONSUME_API_HOTMART_AI_INSTANCE',
  API_COMMUNITY_GATEWAY = 'APP_MEMBERSHIP_COMMUNITY_CONSUME_API_COMMUNITY_GATEWAY_INSTANCE',
  API_CONTENT_SEARCH = 'APP_MEMBERSHIP_COMMUNITY_CONSUME_API_CONTENT_SEARCH_INSTANCE',
  API_MY_ACCOUNT = 'APP_MEMBERSHIP_COMMUNITY_CONSUME_API_MY_ACCOUNT_INSTANCE'
}
